export default "__VITE_ASSET__59cca0f1__"